import axiosInstance from "./config/axiosConfigs";
import { getToken } from "../cookie/authCookie";
import { authHeaders } from "../util/apiEmptyList";

const headers = () => authHeaders(getToken());

export const AdvertisementAPI = {
    getBannersByClub: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/banners/clubId/${clubId}`,
            method: "GET",
            timeout: 15000,
            headers: headers(),
        });
        return { ...response.data, Data: response.data?.Data ?? [] };
    },

    createBanner: async function (banner) {
        const response = await axiosInstance.request({
            url: "/advertisement/banners",
            method: "POST",
            data: banner,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    updateBanner: async function (id, clubId, banner) {
        const response = await axiosInstance.request({
            url: `/advertisement/banners/${id}/clubId/${clubId}`,
            method: "PUT",
            data: banner,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    deleteBanner: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/banners/${id}/clubId/${clubId}`,
            method: "DELETE",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    activateBanner: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/banners/${id}/activate/clubId/${clubId}`,
            method: "PATCH",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    deactivateBanner: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/banners/${id}/deactivate/clubId/${clubId}`,
            method: "PATCH",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    uploadCreative: async function (file, clubId) {
        const formData = new FormData();
        formData.append("file", file);
        formData.append("clubId", clubId);
        const response = await axiosInstance.request({
            url: "/advertisement/creatives",
            method: "POST",
            params: { clubId },
            data: formData,
            timeout: 30000,
            headers: headers(),
        });
        return response.data;
    },

    getDisplayBanners: async function (placement, clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/banners/display?placement=${encodeURIComponent(placement)}&clubId=${clubId}`,
            method: "GET",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    getCampaignsByClub: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/campaigns/clubId/${clubId}`,
            method: "GET",
            timeout: 15000,
            headers: headers(),
        });
        return { ...response.data, Data: response.data?.Data ?? [] };
    },

    createCampaign: async function (campaign) {
        const response = await axiosInstance.request({
            url: "/advertisement/campaigns",
            method: "POST",
            data: campaign,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    updateCampaign: async function (id, clubId, campaign) {
        const response = await axiosInstance.request({
            url: `/advertisement/campaigns/${id}/clubId/${clubId}`,
            method: "PUT",
            data: campaign,
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    deleteCampaign: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/campaigns/${id}/clubId/${clubId}`,
            method: "DELETE",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    pauseCampaign: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/campaigns/${id}/pause/clubId/${clubId}`,
            method: "PATCH",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    activateCampaign: async function (id, clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/campaigns/${id}/activate/clubId/${clubId}`,
            method: "PATCH",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    getDailyAnalytics: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/analytics/daily/clubId/${clubId}`,
            method: "GET",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    getCtrByPlacement: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/analytics/ctr-by-placement/clubId/${clubId}`,
            method: "GET",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },

    getRevenue: async function (clubId) {
        const response = await axiosInstance.request({
            url: `/advertisement/analytics/revenue/clubId/${clubId}`,
            method: "GET",
            timeout: 15000,
            headers: headers(),
        });
        return response.data;
    },
};
